import React, { Component } from 'react';
import Paper                from 'material-ui/Paper';
import Favourite            from './../containers/FavouriteContainer';
import GoBack               from './GoBackIcon';
import ViewMap              from './ViewMapIcon';
import ViewInfo             from './ViewInfoIcon';
import { secondaryBanner }  from './../css/Styles';

import './../css/Place.css';

class PlaceStrap extends Component
{
    renderIcons = () => {
        let icons;
        if (this.props.showIcons)
        {
            if ('map' === this.props.showIcons)
            {
                icons = (
                    <div>
                        { this.props.place.type === 'place' ? <ViewInfo placeId={ this.props.place.id } /> : null }
                        <Favourite />
                    </div>
                );
            }
            else if ('info' === this.props.showIcons)
            {
                icons = (
                    <div>
                        <ViewMap placeId={ this.props.place.id } />
                        <Favourite />
                    </div>
                );
            }
        }

        return icons;
    };

    render() {
        if (null !== this.props.place)
        {
            let { filters } = this.props.theme;

            return (
                <Paper
                    className="place-strap"
                    style={ Object.assign( {}, secondaryBanner, { color: filters.text, backgroundColor: filters.background }) }
                    zDepth={1}
                >
                    <div className="place-strap-text">
                        <div className="icon-left-container">
                            <GoBack />
                        </div>
                        <div className="place-name">
                            { this.props.place.name }
                        </div>
                        <div className="icon-right-container">
                            { this.renderIcons() }
                        </div>
                    </div>
                </Paper>
            );
        }
        else
        {
            return null;
        }
    }
}

export default PlaceStrap;


// WEBPACK FOOTER //
// ./src/components/PlaceStrap.js